import { hasSetScores } from "./hasSetScores";

export const getGameResults = (scoring, sets) => {
  const pointsWin = scoring.pointsWin ? Number(scoring.pointsWin) : 3;
  const pointsTie = scoring.pointsTie ? Number(scoring.pointsTie) : 1;

  const pointsLose = scoring.pointsLoss ? Number(scoring.pointsLoss) : 0;

  let results = {
    result1: 0,
    result2: 0,
    finished: true,
    sets: {},
    totalScore1: 0,
    totalScore2: 0,
    sets1: 0,
    sets2: 0,
    numSetsPlayed: 0,
  };

  let numSets = Number(scoring.numSets || "2");
  const playOff =
    scoring.playOff && (scoring.setsType || 0) === 0 && numSets % 2 !== 0;
  let minNumSetsForPlayOff = Math.round(numSets / 2);

  for (let i = 0; i < Number(scoring.numSets || "2"); i++) {
    let set = sets[i] || {};
    let setScore1 = set.score1;
    let setScore2 = set.score2;
    if (hasSetScores(setScore1, setScore2)) {
      results["numSetsPlayed"]++;
      results.sets[i] = set;
      results.totalScore1 += Number(setScore1);
      results.totalScore2 += Number(setScore2);
      if ((scoring.setsType || 0) === 0) {
        if (Number(setScore1) > Number(setScore2)) {
          results["result1"]++;
          results["sets1"]++;
        } else if (Number(setScore1) < Number(setScore2)) {
          results["result2"]++;
          results["sets2"]++;
        }
        if (
          playOff &&
          (results.result1 === minNumSetsForPlayOff ||
            results.result2 === minNumSetsForPlayOff)
        ) {
          break;
        }
      } else {
        if (Number(setScore1) > Number(setScore2)) {
          results["result1"] += pointsWin;
          results["sets1"]++;
          results["result2"] += pointsLose;
        } else if (Number(setScore1) < Number(setScore2)) {
          results["result1"] += pointsLose;
          results["result2"] += pointsWin;
          results["sets2"]++;
        } else {
          results["result1"] += pointsTie;
          results["result2"] += pointsTie;
        }
      }
    } else {
      results["finished"] = false;
    }
  }

  if (
    scoring.decidingSet &&
    numSets % 2 === 0 &&
    results.result1 === results.result2 &&
    results.finished
  ) {
    results["decidingSet"] = true;
    let decidingSet = sets[Number(scoring.numSets || "2")] || {};
    let setScore1 = decidingSet.score1;
    let setScore2 = decidingSet.score2;
    if (hasSetScores(setScore1, setScore2)) {
      results.sets[Number(scoring.numSets || "2")] = decidingSet;
      if (scoring.decidingSetPoints) {
        results.totalScore1 += Number(setScore1);
        results.totalScore2 += Number(setScore2);
      }
      if ((scoring.setsType || 0) === 0) {
        if (Number(setScore1) > Number(setScore2)) {
          results["result1"]++;
          results["sets1"]++;
        } else if (Number(setScore1) < Number(setScore2)) {
          results["result2"]++;
          results["sets2"]++;
        }
      } else {
        if (Number(setScore1) > Number(setScore2)) {
          results["result1"] += pointsWin;
          results["sets1"]++;
          results["result2"] += pointsLose;
        } else if (Number(setScore1) < Number(setScore2)) {
          results["result1"] += pointsLose;
          results["result2"] += pointsWin;
          results["sets2"]++;
        } else {
          results["result1"] += pointsTie;
          results["result2"] += pointsTie;
        }
      }
    } else {
      results["finished"] = false;
    }
  }

  return results;
};
